<template>
  <div class="relation_tel_login">
    <el-form ref="telFrom" :model="tel" :rules="telRules">
      <el-form-item prop="tel">
        <el-input type="text" v-model="tel.tel" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input type="text" v-model="tel.code" placeholder="请输入验证码">
          <el-button v-if="isCodeShow" slot="append" @click="obtain">获取验证码</el-button>
          <template v-else slot="append">{{secondsCount}}s 后重新获取</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div class="login_three_form_btn">
      <el-button type="primary" class="rg_form_box_form_sub" @click="subForm('telFrom')">关联 / 登录</el-button>
    </div>
    <div class="login_three_form_register_text">
      还没有平台账号？<a @click="updateActive('register')">快速注册！</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'telLogin',
  props: {
    info: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      onOff: false, // 验证码开关
      secondsCount: 0, // 手机验证码初始时间
      isCodeShow: true, // 倒计时显示
      tel: { // 手机参数
        tel: '',
        code: ''
      },
      telRules: {
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.length > 11 || value.length < 8) {
                callback(new Error('长度必须为11数字'))
              } else {
                const regexp = /^1[3456789]\d{9}$/
                if (!regexp.test(value)) {
                  callback(new Error('电话号码格式不对'))
                } else {
                  this.onOff = true
                  callback()
                }
              }
            }
          }
        ],
        code: [
          { required: true, message: '请输入手机验证码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 更新导航选中
    updateActive (name) {
      this.$emit('active', name)
    },
    // 获取验证码
    async obtain () {
      const vueThat = this
      if (vueThat.onOff) {
        vueThat.secondsCount = 60
        // 切换倒计时按钮
        vueThat.isCodeShow = false
        // 倒计时函数
        const timer = setInterval(function () {
          vueThat.secondsCount--
          if (vueThat.secondsCount <= 0) {
            clearInterval(timer)
            vueThat.isCodeShow = true
          }
        }, 1000)
        await vueThat.$store.dispatch('user/send', { number: vueThat.tel.tel, type: 'login' })
      }
    },
    // 提交按钮
    subForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        if (valid) {
          const userInfo = {
            union_id: vueThat.info.union_id,
            headimgurl: vueThat.info.headimgurl,
            nick_name: vueThat.info.nickname,
            tel: vueThat.tel.tel,
            code: vueThat.tel.code,
            type: vueThat.type
          }
          try {
            vueThat.myApi.bindTripartiteTel(userInfo).then(rs => {
              if (rs.data.code === 200) {
                console.log(rs)
                vueThat.$store.commit('user/updateUserInfo', {
                  id: rs.data.data.user_id,
                  name: rs.data.data.user_name,
                  authorization: rs.data.data.token,
                  sig: rs.data.data.sig,
                  is_authentication: rs.data.data.is_authentication,
                  portrait: rs.data.data.portrait
                })
                vueThat.$message.success('登录成功！')
                // 登录腾讯IM
                vueThat.webIM.login({ userID: rs.data.data.user_id + '', userSig: rs.data.data.sig })
                  .then(function (imResponse) {
                    console.log(imResponse.data) // 登录成功
                  }).catch(function (imError) {
                    console.warn('login error:', imError) // 登录失败的相关信息
                  })
                // 登录成功后的跳转
                if (vueThat.$store.state.other.oldUrl === '') {
                  vueThat.$router.push({ name: 'Home' })
                } else {
                  vueThat.$router.go(-1)
                }
              }
            })
          } catch (e) {}
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style>
</style>
